// extracted by mini-css-extract-plugin
export default {"breakpointPostContentAreaMin":"746px","breakpointPostContentAreaSmall":"900px","separator":"_0h0dp","postExcerpt":"I8xG8","postTitle":"saBg5"};